// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { fetch, post } from './axios'


import './assets/css/van.css'
import './assets/css/main.css'


// axios
Vue.prototype.$fetch = fetch
Vue.prototype.$post = post


// Vant UI
import '@vant/touch-emulator';
import { Stepper,ActionSheet,Dialog,Popup,Picker,Toast } from 'vant';

Vue.use(Stepper);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Toast);


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  
  let token = localStorage.getItem('token')

  if (!token || localStorage.getItem('scope') != 'snsapi_userinfo') {
    // 未授权 或没有新授权
    if (to.name !== 'author') {
        // 获取授权 并保存进入的url
        let authUrl = to.fullPath

        localStorage.setItem('authUrl', authUrl)

        next("/author")
        return false
    }

  } else {
    // 已授权

  }

  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js